import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {Col, Row} from "react-bootstrap";
import RecommendationsItem from "../components/RecommendationsItem.js";
import Loader from "../components/BlueButton/Loader.js";
import CustomPagination from "../components/BlueButton/CustomPagination.js";
import {word} from "../word.js";
import AddRepeatedTask from "../components/RepearedTaskComponents/AddRepeatedTask.js";
import Api from "../Api.js";
import qs from "query-string";
import DeleteItem from "../components/RepearedTaskComponents/DeleteItem.js";
import AddRepeatedTaskMany from "../components/RepearedTaskComponents/AddRepeatedTaskMany.js";
import {accountantRequest, taskCompanyRequest, taskManagerRequest} from "../store/actions/task.js";

function RepeatedTask(props) {
    const [show, setShow] = useState(false);
    const [showMulti, setShowMulti] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [tasksData, setTaskData] = useState(null);
    const [loading, setLoading] = useState(false);

    const location = useLocation()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handlePageChange = async (pageNumber) => {
        query.offset = pageNumber === 0 ? '' : (pageNumber - 1) * 10
        const stringify = qs.stringify(query, {addQueryPrefix: true, encode: false});
        navigate(`?${stringify}`, {replace: true});
    };
    useEffect(() => {
        (async () => {
            await dispatch(accountantRequest())
            await dispatch(taskManagerRequest())
            await dispatch(taskCompanyRequest())
        })();
    }, []);
    useEffect(() => {
        (async () =>{
            await getData()
        })()
    }, [location.search]);

    const getData = async () =>{
        try {
            setLoading(true)
            const stringify = qs.stringify(query, {addQueryPrefix: true, encode: false});
            const {data} = await Api.repeatedTasks(stringify)
            setTaskData(data)
            setLoading(false)
        }catch (e) {

        }
    }
    const renderTasks = () => {
        if (!loading) {
            return tasksData?.results?.map((item, index) => (
                <Col sm={6} key={index}>
                    <RecommendationsItem
                        modalShow={() => {
                            setDeleteId(item.id);
                        }}
                        item={item}
                        toLink={`/main_employee/repeated_task/${item.id}`}
                        companyId={`/main_employee/organization/${item.company_id}`}
                        comapanyName={item.company_name}
                        color="rgb(112, 112, 112)"
                        team={item.name}
                        teamText={item.text}
                        imgList={item.task_file}
                        status={item.status}
                        accountant_image={item.accountant_image}
                        date={item.created_date}
                    />
                </Col>
            ));
        } else if (loading) {
            return (
                <div className="loaderMargin">
                    <Loader type="Oval" color="#101C2A" height={30} width={30} />
                </div>
            );
        } else {
            return <div/>;
        }
    };

    return (
        <Wrapper>
            <div className='tasks'>

                <div className="plus-cont" onClick={() => setShow(true)}>
                    <span className='plus'>+</span>
                    <span className="tooltiptext">{word.addItem}</span>
                </div>

                {localStorage.getItem("profession") === "manager" && (
                    <div className="plus-cont" onClick={() => setShowMulti(true)}>
                        <span className='plus'>+</span>
                        <span className="tooltiptext">Ավելացնել առաջադրանքներ մի քանի կազմակերպությունների համար</span>
                    </div>
                )}

                {/*{showMulti && (*/}
                {/*    <NewRepeatedTaskMuchOrgs*/}
                {/*        close={() => setShowMulti(false)}*/}
                {/*        getRepeatedtask={() => setFilter()}*/}
                {/*    />*/}
                {/*)}*/}

                <div className='tasks-cont'>
                    <Row className="flex-row">
                        {renderTasks()}
                    </Row>
                </div>

                {tasksData?.count && !loading && (
                    <div className="d-flex justify-content-center">
                        <CustomPagination
                            currentPage={+query.offset? query.offset/10 + 1  : 1}
                            totalItems={tasksData?.count || 0}
                            itemsPerPage={10}
                            totalPages={tasksData?.count ? Math.ceil(tasksData?.count / 10) : 0}
                            onPageChange={(newPage) => handlePageChange(newPage)}
                        />
                    </div>
                )}
            </div>
            {show?<AddRepeatedTask show={show} onHide={async () => {
                setShow(false)
                await getData()
            }}/>: null}
            {showMulti?<AddRepeatedTaskMany show={showMulti} onHide={async () => {
                setShowMulti(false)
                await getData()
            }}/>: null}
            {deleteId?<DeleteItem open={deleteId} setOpen={setDeleteId} setTask={setTaskData}/>: null}
        </Wrapper>

    );
}

export default RepeatedTask;